import { Component, HostListener, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { LoadingService } from './core/services/loading.service';
import { SaveObjectInLocalServiceService } from './core/services/save-object-in-local-service.service';
import { LoggerService } from './core/services/logger.service';
import { environment } from '@env/environment';
const Logger = new LoggerService('AppComponent');

@Component({
  selector: 'dhl-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  title = 'dhl-portal';

  constructor(
    private readonly router: Router,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    loadingService: LoadingService,
    private readonly storage: SaveObjectInLocalServiceService
  ) {
    this.loadIcons(iconRegistry, sanitizer);
    this.router.events.subscribe((event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          loadingService.show();
          break;
        }
        case event instanceof NavigationEnd: {
          this.router.navigated = false;
          loadingService.hide();
          break;
        }
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          loadingService.hide();
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  ngOnInit() {
    if (environment.production) {
      LoggerService.enableProductionMode();
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent) {
    // Comprobar si el usuario cierra la ventana del navegador o solo la pestaña de la página
    if (event.currentTarget === event.target) {
      // El usuario está cerrando la ventana del navegador
      Logger.info('El usuario está cerrando el navegador');
      // Realiza la acción específica que desees antes de que se cierre la ventana del navegador
      if (!this.storage.getObject('persistenceSession')) {
        Logger.info('Se elimino la sesion del storage');
        this.storage.removeObject('persistenceSession');
        this.storage.removeObject('session');
        this.storage.removeObject('store');
      }
    } else {
      // El usuario está cerrando solo la pestaña de la página
      Logger.info('El usuario está cerrando la pestaña de la página');
      // Realiza la acción específica que desees antes de que se cierre la pestaña de la página
    }
  }

  private loadIcons(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer): void {
    iconRegistry.addSvgIcon('dhl-icon-user-circle', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/user_circle_rgb_black.svg'));
    iconRegistry.addSvgIcon('dhl-icon-shopping-cart', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/shopping_cart_rgb_black.svg'));
    iconRegistry.addSvgIcon('dhl-icon-remove-product', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/trash_bin_delete_rgb_black.svg'));
    iconRegistry.addSvgIcon('dhl-icon-edit', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_edit_black.svg'));
    iconRegistry.addSvgIcon('dhl-icon-block', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_block_user_block.svg'));
    iconRegistry.addSvgIcon('dhl-icon-unblock', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_block_user.svg'));
    iconRegistry.addSvgIcon('dhl-icon-block-red', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_block_user-1-red.svg'));
    iconRegistry.addSvgIcon('dhl-icon-detail', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_detail_gray.svg'));
    iconRegistry.addSvgIcon('dhl-icon-down', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_download.svg'));
    iconRegistry.addSvgIcon('dhl-icon-search', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/search_rgb_red.svg'));
    iconRegistry.addSvgIcon('dhl-icon-delete', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_delete.svg'));
    iconRegistry.addSvgIcon('dhl-icon-new-rol', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic-nuevo_rol.svg'));
    iconRegistry.addSvgIcon('dhl-icon-add-user', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic-agregar_usuario.svg'));
    iconRegistry.addSvgIcon('dhl-icon-admin', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_administrador.svg'));
    iconRegistry.addSvgIcon('dhl-icon-client', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_cliente.svg'));
    iconRegistry.addSvgIcon('dhl-icon-employ', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_empleado.svg'));
    iconRegistry.addSvgIcon('dhl-icon-admin-red', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_administrador-red.svg'));
    iconRegistry.addSvgIcon('dhl-icon-client-red', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_cliente-red.svg'));
    iconRegistry.addSvgIcon('dhl-icon-employ-red', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_empleado-red.svg'));
    iconRegistry.addSvgIcon('dhl-icon-edit-user', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic-editar_usuario.svg'));
    iconRegistry.addSvgIcon('dhl-icon-check-validation', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/validation_check.svg'));
    iconRegistry.addSvgIcon('dhl-icon-error-validation', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/validation_error.svg'));
    iconRegistry.addSvgIcon('dhl-icon-download-white', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/download_rgb_white.svg'));
    iconRegistry.addSvgIcon('dhl-icon-download-red', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/download_rgb_red.svg'));
    iconRegistry.addSvgIcon('dhl-icon-upload-red', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/upload_rgb_red.svg'));
    iconRegistry.addSvgIcon('dhl-icon-guide', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_administrar_guias.svg'));
    iconRegistry.addSvgIcon('dhl-icon-pdf', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/pdf-icon.svg'));
    iconRegistry.addSvgIcon('dhl-icon-print', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_print_guide.svg'));
    iconRegistry.addSvgIcon('dhl-icon-print-b', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_print_guide-b.svg'));
    iconRegistry.addSvgIcon('dhl-icon-masiva', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic-carga_masiva.svg'));
    iconRegistry.addSvgIcon('dhl-icon-tarifa-guia', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic-tarifa_guia.svg'));
    iconRegistry.addSvgIcon('dhl-icon-tarifa-paquete', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic-tarifa_dto-paquete_guias.svg'));
    iconRegistry.addSvgIcon('dhl-icon-tarifa-indi', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic-tarifa_dto-guias_individuales.svg'));
    iconRegistry.addSvgIcon('dhl-icon-pagar', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_pagar_odc.svg'));
    iconRegistry.addSvgIcon('dhl-icon-plus-red', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/plus_rgb_black.svg'));
    iconRegistry.addSvgIcon('dhl-icon-refresh', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_refresh-sync.svg'));
    iconRegistry.addSvgIcon('dhl-icon-cancel', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/cancel.svg'));
    iconRegistry.addSvgIcon('dhl-icon-pdf-a', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/img_pdf-a.svg'));
    iconRegistry.addSvgIcon('dhl-icon-pdf-b', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/img_pdf-b.svg'));
    iconRegistry.addSvgIcon('dhl-icon-add-generic', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/plus_rgb_white.svg'));
    iconRegistry.addSvgIcon('dhl-icon-add-circle-generic', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/plus_circle_rgb_white.svg'));
    iconRegistry.addSvgIcon('dhl-icon-add-report', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/pros_rgb_white.svg'));
    iconRegistry.addSvgIcon('dhl-icon-location', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/location_pin_rgb_black.svg'));
    iconRegistry.addSvgIcon('dhl-icon-info', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/information_rgb_red.svg'));
    iconRegistry.addSvgIcon('dhl-icon-store', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/shop_rgb_black.svg'));
  }
}
